var e=function(e){return e.Create="Create",e.Preview="Preview",e.Edit="Edit",e}({});export{e as DialogType};
//# sourceMappingURL=types.js.map